import classnames from "classnames";
import { Text } from "../text/Text";
import { IIconProps } from "../icons/Icons";
import "./FileUpload.scss";

type FileUploadProps = {
  className?: string;
  inputText: string;
  allowedType?: string;
  textMsg: string;
  Icon?: (props: IIconProps) => JSX.Element;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
};

export const FileUpload = (props: FileUploadProps) => {
  const { className, inputText, allowedType, textMsg, Icon, onChange } = props;

  return (
    <div className={classnames(className)}>
      <div>
        <label className="file-label" htmlFor="file-upload">
          {inputText}
          <input className="file-input" id="file-upload" type="file" accept={allowedType} onChange={onChange} />
        </label>
        <Text lKey={textMsg} className="drag" />
      </div>
      {Icon && <Icon />}
    </div>
  );
};
